<script lang="ts">
  import Wordmark from '$components/Logos/Wordmark.svelte';
  import { isHrefExternal } from '$lib/utils/links';
  import {
    useEncodeDataAttribute,
    type ContentSourceMap,
    type StudioPathLike
  } from '@sanity/svelte-loader';
  import { sanityStudioURL } from '$lib/client';

  export let links: { url: string; text: string }[];
  export let sourceMap: ContentSourceMap | undefined = undefined;
  export let path: StudioPathLike = [];

  $: encodeDataAttribute = useEncodeDataAttribute(links, sourceMap, sanityStudioURL);
</script>

<div class="wrapper">
  <h1 class="wordmark">
    <Wordmark />
  </h1>
  <nav>
    {#each links as link, index}
      <a
        href={link.url}
        target={isHrefExternal(link.url) ? '_blank' : undefined}
        rel="noreferrer noopener"
        tabIndex="0"
        data-sanity={encodeDataAttribute([...path, index, 'text'])}
      >
        {link.text}
      </a>
    {/each}
  </nav>
</div>

<style lang="scss">
  @import 'src/scss/landing.scss';

  .wordmark {
    font-size: 0;
  }
  .wrapper {
    display: grid;
    grid-template-rows: min-content max-content;
    align-items: end;
    padding: 0px;
    gap: 16px;
  }

  nav {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    padding: 0px;
  }
  a {
    @include clickable;
    @include animatedLink(1px);
    font-family: var(--font-family-secondary);
    font-weight: 600;
    -webkit-font-smoothing: auto;
    font-style: normal;
    font-size: 14px;
    color: var(--twist-color-gray-100);
    line-height: 120%;
  }

  @media screen and (min-width: 375px) {
    a {
      font-size: 14px;
    }
  }

  @media screen and (min-width: 768px) {
    .wrapper {
      gap: 17px;
      justify-content: start;
    }
    nav {
      display: flex;
      justify-content: start;
      padding: 0px;
      gap: 16px;
    }
  }

  @media screen and (min-width: 1024px) {
    a {
      font-size: 20px;
      line-height: 120%;
    }
  }

  @media screen and (min-width: 1400px) {
    .wrapper {
      grid-template-rows: auto;
      grid-template-columns: min-content max-content;
      gap: 30px;
    }
    nav {
      gap: 24px;
    }
  }
</style>
